import { PolygraphyProductUrlType } from '../../../../../../../services/exports/Constants';

export default {
  form: {
    url_type: {
      options: {
        [PolygraphyProductUrlType.OnlineShop]: 'Negozio online',
        [PolygraphyProductUrlType.Storefront]: 'Vetrina',
        [PolygraphyProductUrlType.Custom]: 'Personalizzato',
      },
    },
  },
  labels: {
    save_changes_to_see_preview: "Salva le modifiche per vedere l'anteprima",
  },
  buttons: {
    save_and_preview: 'Salva e anteprima',
  },
  toasts: {
    failed_to_load_data: 'Impossibile caricare il prodotto',
    failed_to_save_changes: 'Impossibile salvare le modifiche!',
    changes_got_saved: 'Modifiche salvate!',
  },
};
